/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiemsRulesPLFixedRatesReq
 */
export interface DiemsRulesPLFixedRatesReq {
    /**
     * 
     * @type {number}
     * @memberof DiemsRulesPLFixedRatesReq
     */
    foreignRate: number;
    /**
     * 
     * @type {number}
     * @memberof DiemsRulesPLFixedRatesReq
     */
    domesticRate: number;
    /**
     * 
     * @type {string}
     * @memberof DiemsRulesPLFixedRatesReq
     */
    foreignCurrency?: DiemsRulesPLFixedRatesReqForeignCurrencyEnum;
}

export function DiemsRulesPLFixedRatesReqFromJSON(json: any): DiemsRulesPLFixedRatesReq {
    return DiemsRulesPLFixedRatesReqFromJSONTyped(json, false);
}

export function DiemsRulesPLFixedRatesReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiemsRulesPLFixedRatesReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'foreignRate': json['foreign_rate'],
        'domesticRate': json['domestic_rate'],
        'foreignCurrency': !exists(json, 'foreign_currency') ? undefined : json['foreign_currency'],
    };
}

export function DiemsRulesPLFixedRatesReqToJSON(value?: DiemsRulesPLFixedRatesReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'foreign_rate': value.foreignRate,
        'domestic_rate': value.domesticRate,
        'foreign_currency': value.foreignCurrency,
    };
}

/**
* @export
* @enum {string}
*/
export enum DiemsRulesPLFixedRatesReqForeignCurrencyEnum {
    EUR = 'EUR',
    PLN = 'PLN'
}


